import axios from 'axios';

/**
 * Descarga conjunta en un ZIP de los archivos de la solicitud (ADSREC-0025).
 *
 * Sin `ids` baja todos los que se ven en el detalle; con `ids`, solo esos. El
 * back filtra lo que el usuario puede ver y deja fuera los anulados y los que
 * no están en el disco.
 *
 * @param {number|string} requestId
 * @param {Array<number>|null} ids
 * @param {string} requestCode código de la solicitud (I-12345), para el nombre del ZIP
 */
export async function downloadRequestFilesZip(requestId, ids = null, requestCode = '') {
  const response = await axios.get(`${import.meta.env.VITE_API_URL}/request/${requestId}/files/zip`, {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    params: ids?.length ? { ids } : {},
    responseType: 'blob',
  });

  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = zipFileName(response.headers?.['content-disposition'], requestCode || requestId);
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * El nombre que pone el back en Content-Disposition o, como CORS no deja leer
 * esa cabecera desde otro origen, el mismo nombre armado con el código.
 */
export function zipFileName(contentDisposition, requestCode) {
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(contentDisposition || '');
  if (match) {
    try {
      return decodeURIComponent(match[1]);
    } catch {
      return match[1];
    }
  }

  return `archivos-${String(requestCode).replace(/[^A-Za-z0-9_-]+/g, '-')}.zip`;
}

/** El mensaje del back cuando la respuesta de error llega como blob. */
export async function zipErrorMessage(error) {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return typeof parsed?.value === 'string' ? parsed.value : '';
    } catch {
      return '';
    }
  }

  return typeof data?.value === 'string' ? data.value : '';
}
